<!--<div class="adminButtonGroup">
  <button mat-raised-button [matMenuTriggerFor]="resultsMenu" color="primary" aria-label="Results"><mat-icon>sync</mat-icon>Switch Document</button>
  <mat-menu #resultsMenu="matMenu">
    <button *ngFor="let result of results"
            printSectionId="copyleaksComponent"
            [useExistingCss]="true"
            ngxPrint
            mat-menu-item>{{ result }}</button>
  </mat-menu>
</div> -->

<div *ngIf="waitForResults" class="spinner-overlay">
  <mat-progress-spinner class="spinner" mode="indeterminate"></mat-progress-spinner>
  <p class="message">Waiting for Results...</p>
</div>

<cr-copyleaks-report id="copyleaksComponent"
  [config]="config">
</cr-copyleaks-report>